import { LanguageKeys } from 'src/core/provider/AppMeta';

type PublicVideoTopic = 'SERVICE_PROGRAMME' | 'MY_CREDIT' | 'ABO' | 'LANDINGPAGE' | 'PREMIUM_PROGRAM';

export default class VideoResource {
    public languageIso2: string;
    public src?: string;
    public type?: string;

    constructor(json: any) {
        this.languageIso2 = json.languageIso2;
        this.src = json.resourceUrl;
        this.type = json.resourceUrl == null ? undefined : 'video/mp4';
    }

    get isAvailable(): boolean {
        return this.src != null;
    }

    static publicVideoResource(topic: PublicVideoTopic, languageIso2: LanguageKeys): VideoResource {
        return new VideoResource({ languageIso2, resourceUrl: `/api/video/publicStream/${topic}/${languageIso2}` });
    }
}
